import Vue from 'vue'
import EventBus from '../_event-bus'

Vue.component('vue-accordion-item', {
  template: '#vue-accordion-item-template',
  props: ['item', 'breakpoint', 'desktop_hidden', 'trigger_on_desktop'],
  data() {
    return {
      isOpen: false,
      layout: '',
    }
  },
  methods: {
    handleItemToggle() {
      this.isOpen ? (this.isOpen = false) : (this.isOpen = true)
      if (this.isOpen) {
        this.showContent()
      } else {
        this.hideContent()
      }
    },
    addResizeListener() {
      EventBus.$on('resize', this.setLayout)
    },
    getViewportWidth() {
      return window.innerWidth
    },
    setLayout() {
      this.layout = this.getViewportWidth() <= this.$props.breakpoint ? 'mobile' : 'desktop'
      if (this.$props.desktop_hidden && this.layout === 'desktop') {
        this.showContent()
      } else if (!this.$props.trigger_on_desktop && this.layout === 'desktop') {
        this.showContent()
        this.$refs.title.style.pointerEvents = 'none'
      } else {
        this.hideContent()
        if (this.$refs.title) this.$refs.title.style.pointerEvents = 'all'
      }
    },
    showContent() {
      this.$refs.content.style.height = 'auto'
      const contentHeight = `${this.$refs.content.scrollHeight}px`
      this.$refs.content.style.height = 0
      setTimeout(() => {
        this.$refs.content.style.height = contentHeight
        this.$refs.content.style.opacity = 1
        setTimeout(() => {
          this.$refs.content.style.height = 'auto'
        }, 350)
      }, 100)
    },
    hideContent() {
      const contentHeight = `${this.$refs.content.scrollHeight}px`
      this.$refs.content.style.height = contentHeight
      setTimeout(() => {
        this.$refs.content.style.height = 0
        this.$refs.content.style.opacity = 0
      }, 100)
    },
  },
  mounted() {
    this.setLayout()
    this.isOpen = false
    this.addResizeListener()
  },
})
